import React from "react";
import HeaderContainer from "../Header/HeaderContainer";

import { Affix, Col, Grid, Layout, Row, Space, Typography } from "antd";
import BackBtn from "components/reusables/BackBtn/BackBtnComponent";
import NextStepBtnComponent from "components/reusables/NextStepBtn/NextStepBtnComponent";
import StepFlowComponent from "components/reusables/StepFlow/StepFlowComponent";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import NextBackBtnComponent from "components/reusables/NextBackBtn/NextBackBtnComponent";
import "./Congratulations.scss";
import TextHeaderComponent from "components/reusables/TexlHeader/TextHeaderComponent";
import { CheckOutlined } from "@ant-design/icons";
const { Title } = Typography;
const { useBreakpoint } = Grid;

function CongratulationsContainer() {
  const screens = useBreakpoint();
  return (
    <div id="container">
      <Layout id="body">
        <Space direction="vertical" size={35}>
          <HeaderContainer />
          <Layout
            style={{
              padding: "1rem",
              alignItems: "center",
              maxWidth: "1140px",
              margin: "auto",
            }}
          >
            <TextHeaderComponent />
            <StepFlowComponent current={3} className={""}></StepFlowComponent>
            <Row style={{ justifyContent: "center" }}>
              <Col xs={24} md={20} style={{ maxWidth: "786px" }}>
                <Space size={24} direction="vertical">
                  <div>
                    {/* TODO: move to component */}
                    <Row style={{ paddingTop: `${!screens["lg"] ? '5px' : '20px'}`, margin: 'auto', maxWidth: '800px', justifyContent: 'center' }}>
                      <Col style={{ maxWidth: '630px' }}>
                        <Space size={16} direction="vertical">
                          <Col span={24}>
                            <Title
                              className={"body-text-header"}
                              style={{ textAlign: "center" }}
                            >
                              ¡Transferencia lista!
                            </Title>
                          </Col>
                          <Row>
                            <div>
                              <Title
                                className={"vehicle-buy-text-description"}
                                level={4}
                              >
                                {
                                  <span style={{ fontWeight: "400" }}>
                                    En esta etapa, la institución oficial procesó tu transferencia y
                                    <strong> el vehículo ya está oficialmente a nombre del comprador.</strong>
                                  </span>
                                }
                              </Title>
                            </div>
                          </Row>
                        </Space>
                      </Col>
                    </Row>
                    {/* end move to component */}
                  </div>
                  <div className="Congratulations" style={{ alignItems: "center" }}>
                    {/* {screens["lg"] ? '' : <Divider/>} */}
                    <Space size={32} direction={"vertical"} >
                      <div className={screens["lg"] ? "processInfoPnl" : ''}>
                        <Row style={{ justifyContent: 'center' }}>
                          <Space size={32} direction={'vertical'}>
                            <h3>¿Cómo continua el proceso?</h3>
                            <ul className='list-without-bullets list-with-checks'>
                              <Space size={10} direction={"vertical"}>
                                <li>
                                  <Space size={8}>
                                    <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                    Podrás revisar los documentos asociados a la transferencia y más información.
                                  </Space>
                                </li>
                                <li>
                                  <Space size={8} style={{}}>
                                    <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                    La institución oficial deberá enviar el padrón del vehículo al nuevo propietario a la dirección especificada en el contrato.
                                  </Space>
                                </li>
                              </Space>

                            </ul>
                          </Space>
                        </Row>
                      </div>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}>
                        <Row className="processWarning">
                          <h4 style={{ margin: 0 }}>Importante: ¿Qué documentos son necesarios para realizar el trámite?</h4>
                          <div className="subtitle">Te recomendamos tener estos documentos en tu dispositivo antes de comenzar la transferencia:</div>
                          <ul className='list-without-bullets list-with-checks-dark' style={{ alignSelf: 'stretch' }}>
                            <Space size={10} direction={"vertical"}>
                              <li>
                                <Space size={8}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Permiso de circulación, con toda la información.
                                </Space>
                              </li>
                              <li>
                                <Space size={8}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Certificado de Anotaciones Vigentes - CAV (lo puedes obtener en tu Informe Full).
                                </Space>
                              </li>
                              <li>
                                <Space size={8}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Cédulas de identidad vigentes y en buen estado (fotos por ambos lados en buena calidad)
                                </Space>
                              </li>
                              <li>
                                <Space size={8}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Si es empresa: constitución de la sociedad y certificado de vigencia de la constitución.
                                </Space>
                              </li>
                              <li>
                                <Space size={8} style={{}}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Si son extranjeros: solicitud de residencia en trámite o Visa en trámite (si se tiene cédula vencida)
                                </Space>
                              </li>
                              <li>
                                <Space size={8} style={{}}>
                                  <CheckOutlined style={{ color: '#FF4E04', fontSize: '16px' }} />
                                  Si es transferencia con representación: poder notarial digital.
                                </Space>
                              </li>
                            </Space>
                          </ul>
                        </Row>
                      </div>
                    </Space>
                  </div>
                </Space>
                <Row style={{ justifyContent: "end" }}>
                  <Col md={12} xs={0}>
                    <NextBackBtnComponent
                      id='simTrf-step5-inittransference'
                      value="/opciones/iniciar-transferencia/"
                      rowClassName="rowClassName"
                    ></NextBackBtnComponent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </Space>
      </Layout >
      <Affix offsetBottom={1}>
        <div id="fix-mobile-footer" className="mobileStyle">
          <Row justify="center" align="middle" style={{ padding: "1rem" }}>
            <Col style={{ width: "50%" }}>
              <BackBtn label={"Volver"} title="Volver atrás"></BackBtn>
            </Col>
            <Col style={{ width: "50%" }}>
              <NextStepBtnComponent
                id='simTrf-step5-inittransference'
                value={'/opciones/iniciar-transferencia/'}
                text={"Siguiente"}
                action={() => { }}
              />
            </Col>
          </Row>
        </div>
      </Affix>
      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </div >
  );
}

export default CongratulationsContainer;
